// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/SimpleInfoModal/SimpleInfoModal.css
// module id = 369
// module chunks = 0 1